export default __webpack_public_path__ + "static/media/multiplySFX.ce37f55d.mp3";